import { NavLink } from "react-router-dom";

const DataTable = ({ stations, handleDelete }) => {

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th className="text-left" width="20%">Name</th>
                    <th className="text-left" width="20%">Printer Name</th>
                    <th className="text-left">Description</th>
                    <th className="text-left" width="1%"/>
                    <th className="text-left" width="1%"/>
                </tr>
            </thead>
            <tbody>
                {stations.map(station => 
					<tr key={station.id}>
						<td>{station.name}</td>
						<td>{station.printer}</td>
						<td>{station.description}</td>
						<td className="text-right">
							<NavLink to={`/data/stations/${station.id}`} className="btn btn-primary btn-icon">
                                <span className="las la-pen" />
                            </NavLink>
                        </td>
						<td className="text-right">
							<button className="btn btn-danger btn-icon" onClick={() => handleDelete(station)}>
                                <span className="las la-trash-alt" />
                            </button>
						</td>
					</tr>
				)}
            </tbody>
        </table>
    );
}
 
export default DataTable;